import * as React from 'react'

const Riders = (props: { className: string }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Riders' clipPath='url(#clip0)'>
          <path
            d='M 17.4 9C 19.056 9 20.388 7.56 20.388 5.78571C 20.388 4.01143 19.056 2.57143 17.4 2.57143C 15.744 2.57143 14.4 4.01143 14.4 5.78571C 14.4 7.56 15.744 9 17.4 9ZM 8.4 7.71429C 10.392 7.71429 11.988 5.99143 11.988 3.85714C 11.988 1.72286 10.392 0 8.4 0C 6.408 0 4.8 1.72286 4.8 3.85714C 4.8 5.99143 6.408 7.71429 8.4 7.71429ZM 17.4 11.5714C 15.204 11.5714 10.8 12.7543 10.8 15.1071L 10.8 18L 24 18L 24 15.1071C 24 12.7543 19.596 11.5714 17.4 11.5714ZM 8.4 10.2857C 5.604 10.2857 0 11.79 0 14.7857L 0 18L 8.4 18L 8.4 15.1071C 8.4 14.0143 8.796 12.0986 11.244 10.6457C 10.2 10.4143 9.192 10.2857 8.4 10.2857Z'
            transform='translate(0 3)'
            id='Vector'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Riders



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Riders.tsx